import React, { useMemo } from 'react';
import { Capacitor } from '@capacitor/core';

import { AsaphButton } from '@/components/shared/Button';
import { Loader } from '@/components/shared/Loader';
import { directMessagesUrl } from '@/config/urls';
import { useListMyChatsQuery } from '@/graphql';
import { classNames } from '@/helpers/classNames';
import { useTeam } from '@/providers/TeamProvider';
import { useUnreadChats } from '@/providers/UnreadChatsProvider/UnreadChatsProvider';
import constants from '@/theme/exportedVariables.module.scss';

import { useMediaQuery } from '@material-ui/core';
import { pathOr } from 'ramda';
import { useNavigate } from 'react-router';

import dashboardStyles from '../../Dashboard.module.scss';
import { MessagesCard } from './components/MessagesCard';
import styles from './LatestMessages.module.scss';

const isCapacitor = Capacitor.isNativePlatform();

interface IProps {
	openInvite: () => void;
}

export const LatestMessages: React.FC<IProps> = (props) => {
	const { team } = useTeam();
	const { chatIds } = useUnreadChats();
	const navigate = useNavigate();
	const isTablet = useMediaQuery(`(min-width: ${constants.sizeTablet}`);

	const {
		data: chatsData,
		isLoading,
		error,
	} = useListMyChatsQuery(
		{
			input: {
				limit: 2,
				offset: 0,
			},
		},

		{
			refetchOnWindowFocus: false,
		},
	);

	const lastMessages = useMemo(
		() => chatsData?.listMyChats.slice(0, 10) || [],
		[chatsData?.listMyChats],
	);

	return (
		<div className={styles['latest-messages']}>
			<div className={dashboardStyles['title']}>Latest messages</div>
			{isLoading ? (
				<Loader className={styles['loader']} />
			) : lastMessages.length ? (
				<div
					className={classNames([
						styles['list'],
						isTablet && styles['scroll-padding'],
					])}
				>
					{lastMessages.map((chat) => (
						<MessagesCard
							key={`chat-${chat.id}`}
							chat={chat}
							noHover={isCapacitor}
							hasNotification={chatIds.includes(chat.id)}
						/>
					))}
				</div>
			) : (
				<div className={styles['wrapper']}>
					<p>Send a new message to an individual or group</p>
					<AsaphButton
						color="blue"
						label="New message"
						onClick={() => navigate(directMessagesUrl)}
						fullWidth
					/>
				</div>
			)}
		</div>
	);
};

export function getFirstName(name: string): string {
	const splitName = name.split(' ');
	return pathOr('', [0], splitName);
}
